VjsAdmin.VjsAdminUserForm = (function () {
    function validatePasswordLength() {
        const password = $('#password').val();
        if (password.length >= 8 && password.length <= 100) {
            $('#password').removeClass('is-invalid');
            enableSubmit();
            return true;
        }
        $('#password').addClass('is-invalid');
        disableSubmit();
        return false;
    }

    function validatePasswordMatch() {
        const password = $('#password').val();
        const passwordConfirm = $('#password_confirm').val();
        if (password === passwordConfirm) {
            $('#password_confirm').removeClass('is-invalid');
            validatePasswordLength();
            return true;
        }
        $('#password_confirm').addClass('is-invalid');
        disableSubmit();
        return false;
    }

    function disableSubmit() {
        $('input[type=submit]').prop('disabled', true).attr('title', 'Please fill out all required fields.');
    }

    function enableSubmit() {
        $('input[type=submit]').prop('disabled', false).attr('title', '');
    }

    // POD-3278: the value the SSO Credential should mirror from a username, or '' when the
    // username is not an email address (the field is type=email, so a plain name would block submit).
    function ssoCredentialFromUsername(username) {
        const value = (username || '').trim().toLowerCase();
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? value : '';
    }

    // Add form only (data-autofill-from is rendered for caller == 'add'): mirror the username into
    // the SSO Credential until the admin edits that field themselves; from then on their value
    // (including a deliberate blank) is left alone.
    function initSsoCredentialAutofill() {
        const $sso = $('#sso_credential[data-autofill-from]');
        if (!$sso.length) {
            return;
        }
        const $source = $($sso.data('autofill-from'));
        const current = $sso.val().trim().toLowerCase();
        // re-rendered after a validation error: a value that differs from the username was typed by hand
        let manual = current !== '' && current !== ssoCredentialFromUsername($source.val());

        $sso.on('input', () => {
            manual = true;
        });
        $source.on('input change', () => {
            if (!manual) {
                $sso.val(ssoCredentialFromUsername($source.val()));
            }
        });
        if (!manual) {
            $sso.val(ssoCredentialFromUsername($source.val()));
        }
    }

    const init = function () {
        initSsoCredentialAutofill();

        $('#generate-password').on('click', (e) => {
            e.preventDefault();
            let newPassword = $.passGen({ length: 10 });
            newPassword = newPassword.replace(/l/g, 'L');
            newPassword = newPassword.replace(/1/g, 'X');
            newPassword = newPassword.replace(/0/g, 'Z');
            newPassword = newPassword.replace(/O/g, 'Z');
            newPassword = newPassword.replace(/o/g, 'z');
            $('#password,#password_confirm').val(newPassword).attr('type', 'text').trigger('input');
        });

        $('#password, #password_confirm').on('input', () => {
            validatePasswordLength();
            validatePasswordMatch();
        });
    };

    return {
        init,
    };
}());
